
export type NotificationBasicInfoType = typeof NotificationBasicInfoType[keyof typeof NotificationBasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationBasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
